import storeManager from '../../../store/StoreManager';
import appParameters from '../../../components/utils/AppParameters';
import moodsUtils from '../../../components/utils/MoodsUtils';
import zipLoader from './ZipLoader';
import masterUniverseUtils from '../../utils/MasterUniverseUtils';
import { addClipartModel } from '../../../actions/AccordionActions';

const videoClipartParserJSON = {
    parseClipartModel(arrayData) {
        const categories = ['Video clips'];
        var i;
        var j;
        var clipartModel = {};
        var item;

        clipartModel.captionKey = arrayData[0].theme;
        appParameters.currentVideoTheme = clipartModel.captionKey;

        clipartModel.items = [];

        for (i=0; i<categories.length; i++) {
            item = {};
            item.title = categories[i];
            item.items = [];

            for (j=0; j<arrayData.length; j++) {
                var resourceObject = arrayData[j];

                var resource = {};
                resource.theme = resourceObject.theme;
                resource.title = this.getTitle(resourceObject);
                resource.href = 'https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/' + this.getCorrectTheme(resourceObject.theme) + '/' + resourceObject.logicalname + '.mp4';
                resource.thumbnailUrl = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/' + resourceObject.logicalname + '.jpg';

                item.items.push(resource);
            }

            clipartModel.items.push(item);
        }

        this.addClipartModelHandler(clipartModel);
    },
    getCorrectTheme(theme) {
        if (theme.indexOf('italy') != -1 || theme.indexOf('morocco') != -1 || theme.indexOf('norway') != -1)
            return 'places';
        else
            return theme;
    },
    getTitle(item) {
        if (!item.translations)
            return item.logicalname;
        else {
            var translation = item.translations[masterUniverseUtils.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (item.translations['en_US'])
                return item.translations['en_US'];
            else
                return item.logicalname;
        }
    },
    addClipartModelHandler(clipartModel) {
        moodsUtils.clipartModel = clipartModel;

        const state = storeManager.getState();

        if (state.music.soundClipartModel == undefined)
            zipLoader.loadData('audio');

        this.updateClipartModelToState();
    },
    updateClipartModelToState() {
        const store = storeManager.getStore();
        store.dispatch(addClipartModel(moodsUtils.clipartModel));
    },
    parseSearchItems(items) {
        if (!items)
            return [];

        var i;
        var newItems = [];

        for (i=0; i<items.length; i++) {
            var resourceObject = items[i];
            var resource = {};

            resource.theme = resourceObject.theme;
            resource.title = this.getTitle(resourceObject);
            resource.href = 'https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/' + this.getCorrectTheme(resourceObject.theme) + '/' + resourceObject.logicalname + '.mp4';
            resource.thumbnailUrl = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/' + resourceObject.logicalname + '.jpg';

            newItems.push(resource);
        }

        return newItems;
    }
};

export default videoClipartParserJSON;



/** WEBPACK FOOTER **
 ** ./src/components/accordion/clipartUtils/VideoClipartParserJSON.js
 **/